export default __webpack_public_path__ + "assets/images/keksi-f7d2a57a0fd9323111287224ca1c212b.png";